import React from "react";
//#region types
import { FileViewerInnerProps } from "models/propTypes/fileViewerPropTypes";
import { FileEnums } from "models/enums";
//#endregion
//#region components
import FileViewerNoPreview from "./fileViewerNoPreview";
import FileViewerHtml from "./fileViewerHtml";
import FileViewerPDF from "./fileViewerPDF";
import FileViewerImage from "./fileViewerImage";
import { FileHelper } from "utils/helpers";
//#endregion

const FileViewerInner: React.FC<FileViewerInnerProps> = (props) => {
  const getComponent = (contentType: string) => {
    if (!contentType) {
      return FileViewerNoPreview;
    }
    switch (contentType.toLowerCase()) {
      case "html":
        return FileViewerHtml;
      case FileEnums.ContentTypes.ApplicationPDF:
        return FileViewerPDF;
      case FileEnums.ContentTypes.ImagePNG:
      case FileEnums.ContentTypes.ImageXPNG:
      case FileEnums.ContentTypes.ImageJPG:
      case FileEnums.ContentTypes.ImageJPEG:
      case FileEnums.ContentTypes.ImagePJPG:
      case FileEnums.ContentTypes.ImageBMP:
      case FileEnums.ContentTypes.ImageHEIC:
      case FileEnums.ContentTypes.ImageHEIF:
        return FileViewerImage;
      default:
        return FileViewerNoPreview;
    }
  };

  const contentType = FileHelper.normalizeContentType(props.currentFile.fileName, props.currentFile.contentType);
  const InnerComponent = !props.isLoading && !props.currentFile.data ? FileViewerNoPreview : getComponent(contentType);

  return contentType !== undefined ? <InnerComponent {...props} currentFile={{ ...props.currentFile, contentType }} /> : <></>;
};

export default FileViewerInner;
